import React from 'react'
import {useState, useEffect} from 'react';
import Question from '../../components/question';
import { firebaseApp } from '../../helpers/firebase'; 
import { Link } from 'react-router-dom';
import { getFirestore } from "firebase/firestore"
import { doc, getDoc } from "firebase/firestore";

function Faq() {

  const [isLoading, setIsLoading] = useState(null);
  const [questions, setQuestions] = useState([]);
  const clickHandler = (e) => {
    const isFaqRead = localStorage.getItem('isFaqRead');
    if(!isFaqRead){
      localStorage.setItem('isFaqRead', true);
    }
  }

  useEffect(() => {
    async function getFAQ() {
      setIsLoading(true)

      const db = getFirestore(firebaseApp);      
      const docRef = doc(db, "bot_settings" ,"landing_faq");
      const docSnap = await getDoc(docRef);
    
      if (docSnap.exists()) {
        const questions = docSnap.data();
        setQuestions(Object.values(questions).sort((a,b) => a[2] - b[2]))
      } else {
        console.log("No such document!");
      }
      setIsLoading(false)
    }
    getFAQ()
  }, [])


  return (
    <div className="main">
      <div className="container faq_width">
        <h1 className="faq_title">FAQ</h1>
        <div className="faq_container">
          {isLoading ? <h1>Loading</h1> : (
            questions.map(question => <Question questionText={question[0]} key={question[2]} answerText={question[1]} />)
          )}
        </div>
        <div className="faq_return_container">
          <Link className="faq_return" to="/main" onClick={ clickHandler }>
              Вернуться к статистике бота
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Faq